export default __webpack_public_path__ + "static/media/Love03.63b37f9a.png";